import axios from 'axios'
import { push } from 'connected-react-router'

export function fetchVoucher(id) {
  return (dispatch) =>
    dispatch({
      type: 'VOUCHER_FETCH',
      payload: axios(`/vouchers/${id}`),
    })
}

export function createVoucher(data) {
  return (dispatch) => {
    dispatch({
      type: 'VOUCHER_CREATE',
      payload: axios.post('/vouchers', data),
    }).then(({ value }) => {
      dispatch(push(`/vouchers/${value.data.id}/pay`))
    })
  }
}

export function payVoucher(id, data) {
  return (dispatch) => {
    dispatch({
      type: 'VOUCHER_PAY',
      payload: axios.post(`/vouchers/${id}/pay`, data),
    }).then(() => {
      dispatch(push(`/vouchers/${id}/success`))
    })
  }
}
